
import { Component, Vue } from "vue-property-decorator";
import { assetsUrl } from "@/env";
@Component({ name: "NotFound" })
export default class NotFound extends Vue {
  getImageSrc(slug: string): string {
    return `${assetsUrl}/svg/${slug}`;
  }
}
